export default __webpack_public_path__ + "static/page-preview-fallback-3e6f9216bc7d35233644be61ea667e13.jpg";